import React from 'react'

const NotFound = () => (
  <div className="text-center container pt-5 pb-5 mb-5">
    <div style={{ fontSize: '10rem' }}>
      <i className="fa fa-question-circle" />
    </div>
    <h1>Page not found</h1>
    <p>Computer says no... Have you signed into the correct workspace?</p>
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/components/404.jsx